<template>
  <div class="general-wrapper">
    <Header parent="corporate_users">
      <template #title>
        {{ $t("auditlog.title") }}
      </template>
    </Header>
     
    <IQOSTable
      :cols="[
        {
          title: $t('auditlog.columns.user'),
          renderer: (u) => `${u.user_name} (${u.user_email})`
        },
        {
          title: $t('auditlog.columns.date'),
          key: 'created_at',
          date: true,
          width: 160
        },
        {
          title: $t('auditlog.columns.time'),
          key: 'created_at',
          width: 80,
          time: true
        },
        {
          title: $t('auditlog.columns.action'),
          renderer: (e) => $t(`auditlog.types.${e.type}`, e.payload) 
        },
      ]"
      :rows="entries">

    </IQOSTable>
  </div>
</template>

<style scoped>
  

.qrw-simple-table td {
  padding: 1vh 0;
}

.cafe-selector {
  max-width: 35vh;
}

</style>

<script>
import AuditlogAPI from "@/api/auditlog";

import BlackSelect from "@/components/BlackSelect.vue";

export default {
  data() {
    return {
      entries: [],

      selected_cafe: null,
    };
  },
  watch: {
    selected_cafe() {
      this.fetchEntries();
    },
  },
  methods: {
    fetchEntries() {
      AuditlogAPI.getEntries(this.selected_cafe)
        .then((data) => {
          this.entries = data.entries;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {
    corporate_cafes() {
      return this.$store.state.corporate_cafes;
    },
  },
  mounted() {
    this.selected_cafe = this.$store.state.cafe._id;
    this.fetchEntries();
  },
  components: {
    BlackSelect,
  },
};
</script>
